;
define("product_views_option_tile.tpl", function(){});

